var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-card", { attrs: { title: "Pasos" } }, [
        _c(
          "form",
          {
            staticClass: "pb-5",
            attrs: { "data-vv-scope": "steps", autocomplete: "off" },
            on: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _vm.form.stepType === _vm.stepTypesMap.OFFICE
              ? _c("div", [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-6" }, [
                      _c("label", [
                        _vm._v("Este tipo de paso sera una oficina")
                      ]),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-around" },
                        [
                          _c(
                            "b-form-radio",
                            {
                              attrs: {
                                plain: "",
                                name: "some-radios3",
                                value: "I"
                              },
                              model: {
                                value: _vm.form.officeType,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "officeType", $$v)
                                },
                                expression: "form.officeType"
                              }
                            },
                            [_vm._v(" Interna ")]
                          ),
                          _c(
                            "b-form-radio",
                            {
                              attrs: {
                                plain: "",
                                name: "some-radios4",
                                value: "P"
                              },
                              model: {
                                value: _vm.form.officeType,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "officeType", $$v)
                                },
                                expression: "form.officeType"
                              }
                            },
                            [_vm._v(" De partes ")]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ])
              : _vm._e(),
            !_vm.readOnly
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-3" },
                    [
                      _c(
                        "vs-select",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          ref: "stepType",
                          staticClass: "w-100",
                          attrs: {
                            autocomplete: "",
                            label: "Tipo de paso",
                            name: "stepType",
                            danger: _vm.errors.has("steps.stepType"),
                            "danger-text": _vm.errors.first("steps.stepType")
                          },
                          model: {
                            value: _vm.form.stepType,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "stepType", _vm._n($$v))
                            },
                            expression: "form.stepType"
                          }
                        },
                        _vm._l(_vm.stepTypesAvalaibles, function(type) {
                          return _c("vs-select-item", {
                            key: type.opcionId,
                            attrs: { value: type.valor, text: type.descripcion }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm.form.stepType === _vm.stepTypesMap.OFFICE
                    ? _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("list-offices", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required:
                                    _vm.form.stepType ===
                                    _vm.stepTypesMap.OFFICE
                                },
                                expression:
                                  "{ required: form.stepType === stepTypesMap.OFFICE }"
                              }
                            ],
                            ref: "groupStep",
                            staticClass: "w-100 mb-1",
                            attrs: {
                              autocomplete: "",
                              label: "Oficina del responsable (*)",
                              name: "groupStep",
                              "data-vv-as": "oficina",
                              typeList: _vm.form.officeType === "I" ? 99 : 98,
                              "validate-lider": "",
                              withFilters: "",
                              officeType:
                                _vm.form.officeType === "I"
                                  ? "numInt"
                                  : "numOf",
                              danger: _vm.errors.has("steps.groupStep"),
                              "danger-text": _vm.errors.first("steps.groupStep")
                            },
                            model: {
                              value: _vm.form.groupStep,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "groupStep", $$v)
                              },
                              expression: "form.groupStep"
                            }
                          }),
                          _c("small", { staticClass: "text-danger" }, [
                            _vm._v(
                              " Si le falta una oficina, favor notificar al equipo de Soporte para que verifiquen que esté correctamente configurada "
                            )
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.stepType === _vm.stepTypesMap.GROUP
                    ? _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("list-groups", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required:
                                    _vm.form.stepType === _vm.stepTypesMap.GROUP
                                },
                                expression:
                                  "{ required: form.stepType === stepTypesMap.GROUP }"
                              }
                            ],
                            ref: "groupStep",
                            staticClass: "w-100",
                            attrs: {
                              autocomplete: "",
                              label: "Grupo del responsable",
                              name: "groupStep",
                              typeList: _vm.form.stepType,
                              danger: _vm.errors.has("steps.groupStep"),
                              "danger-text": _vm.errors.first("steps.groupStep")
                            },
                            model: {
                              value: _vm.form.groupStep,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "groupStep", $$v)
                              },
                              expression: "form.groupStep"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.stepType === _vm.stepTypesMap.USER
                    ? _c(
                        "div",
                        { staticClass: "col-6" },
                        [
                          _c("list-user", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: {
                                  required:
                                    _vm.form.stepType === _vm.stepTypesMap.USER
                                },
                                expression:
                                  "{ required: form.stepType === stepTypesMap.USER }"
                              }
                            ],
                            ref: "userStep",
                            staticClass: "w-100",
                            attrs: {
                              autocomplete: "",
                              label: "Usuario",
                              name: "userStep",
                              danger: _vm.errors.has("steps.userStep"),
                              "danger-text": _vm.errors.first("steps.userStep")
                            },
                            model: {
                              value: _vm.form.userStep,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "userStep", $$v)
                              },
                              expression: "form.userStep"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "col-3" },
                    [
                      _c(
                        "vs-select",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "w-100",
                          attrs: {
                            autocomplete: "",
                            label: "Tipo de rol",
                            name: "rolType",
                            danger: _vm.errors.has("steps.rolType"),
                            "danger-text": _vm.errors.first("steps.rolType")
                          },
                          model: {
                            value: _vm.form.rolType,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "rolType", $$v)
                            },
                            expression: "form.rolType"
                          }
                        },
                        _vm._l(_vm.rolTypesAvalaibles, function(rol) {
                          return _c("vs-select-item", {
                            key: rol.opcionId,
                            attrs: { value: rol.valor, text: rol.descripcion }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            !_vm.readMode
              ? _c("div", { staticClass: "row mb-3" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 d-flex align-items-end justify-content-end"
                    },
                    [
                      _vm.exampleFile
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal",
                                  value: "config-signs",
                                  expression: "'config-signs'"
                                }
                              ],
                              staticClass: "mr-2",
                              attrs: {
                                "data-cy": "configure-sign",
                                variant: "info",
                                disabled: _vm.loading
                              }
                            },
                            [_vm._v(" Configurar firmas ")]
                          )
                        : _vm._e(),
                      !_vm.readOnly
                        ? _c("UploadFile", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: "Agregar archivo preview",
                                expression: "'Agregar archivo preview'"
                              }
                            ],
                            staticClass: "mt-2 mr-3",
                            attrs: {
                              permission: "*",
                              color: "secondary",
                              text: "Cargar archivo de muestra",
                              accept: "*",
                              "upload-to": "ed"
                            },
                            model: {
                              value: _vm.filePreview,
                              callback: function($$v) {
                                _vm.filePreview = $$v
                              },
                              expression: "filePreview"
                            }
                          })
                        : _vm._e(),
                      !_vm.readOnly
                        ? _c(
                            "b-button",
                            {
                              attrs: {
                                "data-cy": "add-step",
                                variant: "primary",
                                icon: "add",
                                disabled: _vm.loading
                              },
                              on: {
                                click: function($event) {
                                  return _vm.addStep()
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.loading
                                      ? "Agregando paso..."
                                      : "Agregar paso"
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.steps.length
              ? _c(
                  "div",
                  {
                    staticClass: "row scroll",
                    class: { minHeigth: !_vm.readMode }
                  },
                  _vm._l(_vm.steps, function(step, index) {
                    return _c(
                      "div",
                      { key: "step-" + index, staticClass: "col-4 mb-2" },
                      [
                        _c("div", { staticClass: "step-wrapper" }, [
                          _c(
                            "span",
                            {
                              staticClass: "step-number",
                              attrs: { "data-cy": "step" }
                            },
                            [_vm._v(_vm._s(step.numeroPaso))]
                          ),
                          _vm.readMode
                            ? _c(
                                "span",
                                { staticClass: "step-delete" },
                                [
                                  _c("vs-icon", {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover.left",
                                        value: "Ver detalles",
                                        expression: "'Ver detalles'",
                                        modifiers: { hover: true, left: true }
                                      }
                                    ],
                                    attrs: {
                                      icon: "info",
                                      size: "small",
                                      bg: "white",
                                      round: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.configureStep(step)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.readMode
                            ? _c(
                                "span",
                                { staticClass: "step-delete" },
                                [
                                  _c("vs-icon", {
                                    attrs: {
                                      "data-cy": "configure-step",
                                      title: "Configurar paso",
                                      icon: "settings",
                                      size: "small",
                                      bg: "white",
                                      round: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.configureStep(step)
                                      }
                                    }
                                  }),
                                  _c("vs-icon", {
                                    attrs: {
                                      icon: "highlight_off",
                                      size: "small",
                                      bg: "white",
                                      color: "danger",
                                      round: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeStep(step)
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value:
                                    step.subrogado && step.subrogado.length
                                      ? "Subrogado"
                                      : "",
                                  expression:
                                    "(step.subrogado && step.subrogado.length) ? 'Subrogado' : ''"
                                }
                              ],
                              staticClass:
                                "cursor-default text-center step-name"
                            },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: "Responsable anterior",
                                      expression: "'Responsable anterior'"
                                    }
                                  ],
                                  staticClass: "responsible"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        step.subrogado && step.subrogado.length
                                          ? step.responsable
                                          : ""
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c("br"),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    step.subrogado && step.subrogado.length
                                      ? step.subrogado + " (S)"
                                      : "" + step.responsable
                                  ) +
                                  " "
                              ),
                              step.aprobacionesTipoPasoId ===
                              _vm.stepTypesMap.GROUP
                                ? _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value:
                                            "Cantidad de usuarios en el grupo",
                                          expression:
                                            "'Cantidad de usuarios en el grupo'"
                                        }
                                      ],
                                      staticClass: "cursor-default"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            "(" + step.grupoUsuarios + ")"
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c("br"),
                              step.subrogadoDesde && step.subrogadoDesde.length
                                ? _c(
                                    "span",
                                    { staticClass: "cursor-default" },
                                    [
                                      _vm._v(" Desde: "),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("dateFormat")(
                                              step.subrogadoDesde
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _c("br"),
                              step.subrogadoHasta && step.subrogadoHasta.length
                                ? _c(
                                    "span",
                                    { staticClass: "cursor-default" },
                                    [
                                      _vm._v(" Hasta: "),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("dateFormat")(
                                              step.subrogadoHasta
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm.flowType === "P"
                            ? _c("div", { staticClass: "step-amount" }, [
                                _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(step.desdePrecio) +
                                      " " +
                                      _vm._s(step.desdePrecioMoneda) +
                                      " "
                                  )
                                ])
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "step-types" }, [
                            step.aprobacionesTipoPasoId ===
                            _vm.stepTypesMap.USER
                              ? _c(
                                  "span",
                                  { staticClass: "bg-secondary badges" },
                                  [_vm._v(" Usuario ")]
                                )
                              : _vm._e(),
                            step.aprobacionesTipoPasoId ===
                            _vm.stepTypesMap.GROUP
                              ? _c("span", { staticClass: "blue badges" }, [
                                  _vm._v(" Grupo ")
                                ])
                              : _vm._e(),
                            step.aprobacionesTipoPasoId ===
                            _vm.stepTypesMap.OFFICE
                              ? _c("span", { staticClass: "blue badges" }, [
                                  _vm._v(" Oficina ")
                                ])
                              : _vm._e(),
                            step.distributed
                              ? _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        value:
                                          "Distribuido: se asigna a 1 persona del grupo secuencialmente",
                                        expression:
                                          "'Distribuido: se asigna a 1 persona del grupo secuencialmente'",
                                        modifiers: { hover: true }
                                      }
                                    ],
                                    staticClass: "bg-warning badges"
                                  },
                                  [
                                    _c("vs-icon", {
                                      attrs: { icon: "share", size: "12px" }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]),
                          _c("div", { staticClass: "step-roles" }, [
                            step.aprobacionesTipoRolId ===
                              _vm.rolTypesMap.CONFIGURATOR ||
                            parseInt(step.aprobacionesTipoRolId) ===
                              _vm.rolTypesMap.CONFIGURATOR
                              ? _c("span", { staticClass: "bg-info badges" }, [
                                  _vm._v(" Configurador ")
                                ])
                              : _vm._e(),
                            step.aprobacionesTipoRolId ===
                            _vm.rolTypesMap.APPROVER
                              ? _c("span", { staticClass: "bg-info badges" }, [
                                  _vm._v(" Aprobador ")
                                ])
                              : _vm._e(),
                            step.aprobacionesTipoRolId ===
                              _vm.rolTypesMap.SIGNER &&
                            step.aprobacionesTipoPasoId !==
                              _vm.stepTypesMap.OFFICE
                              ? _c(
                                  "span",
                                  { staticClass: "bg-success badges" },
                                  [_vm._v(" Firmante ")]
                                )
                              : _vm._e(),
                            step.aprobacionesTipoRolId ===
                              _vm.rolTypesMap.SIGNER &&
                            step.aprobacionesTipoPasoId ===
                              _vm.stepTypesMap.OFFICE
                              ? _c(
                                  "span",
                                  { staticClass: "bg-success badges" },
                                  [_vm._v(" Numerar/tramitar ")]
                                )
                              : _vm._e(),
                            step.aprobacionesTipoRolId ===
                            _vm.rolTypesMap.REVIEWER
                              ? _c(
                                  "span",
                                  { staticClass: "bg-warning badges" },
                                  [_vm._v(" Revisor ")]
                                )
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            !_vm.readMode && _vm.error !== ""
              ? _c("div", { staticClass: "pt-5 mt-5 text-right text-danger" }, [
                  _c("span", { staticClass: "mt-5" }, [
                    _vm._v(" " + _vm._s(_vm.error) + " ")
                  ])
                ])
              : _vm._e()
          ]
        )
      ]),
      _c(
        "b-modal",
        {
          ref: "configModal",
          attrs: {
            "hide-footer": "",
            "no-close-on-backdrop": "",
            hideHeaderClose: "",
            centered: "",
            size: "lg"
          }
        },
        [
          _c("ConfigureStepModal", {
            ref: "configureStep",
            attrs: {
              flowType: _vm.flowType,
              step: _vm.stepToConfigure,
              file: _vm.filePreview,
              steps: _vm.steps,
              signatures: _vm.signatureSteps,
              reference: _vm.reference,
              modifyStep: _vm.modifyStep,
              readOnly: _vm.readOnly
            },
            on: {
              close: function($event) {
                return _vm.$refs.configModal.hide()
              },
              "update-sign-position": _vm.updateSignPosition
            }
          })
        ],
        1
      ),
      _c("ConfigureSigns", {
        attrs: {
          step: _vm.stepToConfigure,
          file: _vm.exampleFile,
          steps: _vm.steps,
          signatures: _vm.signatureSteps
        },
        on: {
          "update-sign-position": _vm.updateSignPosition,
          "cancel-action": _vm.cancelModification
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }